export default {
  namespaced: true,
  state: {
    recipient: {},
  },
  getters: {
    recipient: state => state.recipient,
    countryId: state => state.recipient.countryId
  },
  actions: {
    resetCurrentDeclaration: (context) => {
      context.commit('resetCurrentDeclaration');
    },
    setRecipient: (context, recipient) => {
      context.commit("setRecipient", recipient);
    }
  },
  mutations: {
    resetCurrentDeclaration: (state) => {
      state.recipient = {};
    },
    setRecipient: (state, recipient) => {
      state.recipient = { ...recipient }; //make a "deep" copy
    }
  }
}
